import { createStrictContext } from "@indietabletop/appkit";
import { useParams } from "wouter";
import type { Warband } from "../engine/Warband";

export const [WarbandContext, useWarbandContext] =
  createStrictContext<Warband>();

export function useKnightResult() {
  const params = useParams<{ knightId: string }>();
  const warband = useWarbandContext();
  return warband.getKnight(params.knightId);
}
